import React, { useEffect, useState } from 'react';

const FloatingWhatsapp = ({ side = 'right', offsetBottom = 140 }) => {
  const [waLink, setWaLink] = useState(null);

  useEffect(() => {
    const loadSocial = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL
          ? `${process.env.REACT_APP_API_URL}/api/sociallink`
          : '/api/sociallink';
        let rawWa = null;
        try {
          const res = await fetch(apiUrl);
          const data = await res.json();
          const record = Array.isArray(data) ? data[0] || {} : {};
          rawWa = record.whatsapp || record.wa || null;
        } catch (_) {
          // ignore fetch errors, will fallback to localStorage
        }

        // Fallback to localStorage 'whatsapp' set by General API
        if (!rawWa) {
          const lsWa = localStorage.getItem('whatsapp');
          rawWa = lsWa && lsWa !== 'null' ? lsWa : null;
        }

        let link = null;
        if (rawWa) {
          // If already a URL, use as is; else treat as phone number
          if (/^https?:\/\//i.test(rawWa)) {
            link = rawWa;
          } else {
            const digits = String(rawWa).replace(/[^0-9]/g, '');
            link = digits
              ? `https://api.whatsapp.com/send/?phone=${digits}&text&type=phone_number&app_absent=0`
              : null;
          }
        }
        setWaLink(link);
      } catch (e) {
        setWaLink(null);
      }
    };

    loadSocial();
  }, []);

  if (!waLink) return null;

  const handleClick = (e) => {
    e.preventDefault();
    try {
      window.open(waLink, '_blank');
    } catch (e) {
      // noop
    }
  };

  const fixedStyle = {
    position: 'fixed',
    zIndex: 1100,
    bottom: '158px',
    ...(side === 'right' ? { right: '16px' } : { left: '16px' }),
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#25D366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '2px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.25)'
  };

  return (
    <a
      href={waLink}
      onClick={handleClick}
      className={`floating-whatsapp ${side}`}
      aria-label="Contact via WhatsApp"
      title="WhatsApp"
      style={fixedStyle}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path d="M20 12c0 4.418-3.582 8-8 8-1.392 0-2.702-.354-3.845-.977L4 20l1.016-4.12C4.37 14.734 4 13.407 4 12c0-4.418 3.582-8 8-8s8 3.582 8 8Z" fill="#25D366"/>
        <path d="M12.003 6.75c-2.9 0-5.253 2.354-5.253 5.253 0 1.043.309 2.018.84 2.835l-.55 2.232 2.277-.537c.79.469 1.713.741 2.686.741 2.9 0 5.253-2.354 5.253-5.253s-2.353-5.271-5.253-5.271Zm2.993 7.703c-.13.364-.752.693-1.04.74-.285.045-.649.065-1.046-.066-.241-.077-.553-.18-.956-.352-1.68-.693-2.78-2.216-2.865-2.319-.083-.103-.683-.907-.683-1.733 0-.826.429-1.226.58-1.393.15-.167.33-.209.439-.209.111 0 .222.002.319.006.103.005.241-.039.378.289.137.326.466 1.134.508 1.215.042.083.07.179.013.289-.058.11-.087.179-.172.275-.083.096-.176.215-.252.289-.083.083-.17.173-.073.34.098.167.436.717.937 1.16.644.574 1.188.751 1.355.834.167.083.262.073.357-.038.096-.111.412-.48.522-.646.11-.167.219-.14.368-.083.15.056.948.448 1.111.529.16.083.268.122.308.189.041.067.041.389-.089.753Z" fill="#fff"/>
      </svg>
    </a>
  );
};

export default FloatingWhatsapp;
